import { DialogYoutubeComponent } from './dialog-youtube.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
      DialogYoutubeComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
      DialogYoutubeComponent
  ]
})
export class DialogYoutubeModule { }
